import React, { useCallback, useContext } from 'react';
import { CircleIcon, FlexSpace, Modal } from '@ubeya/shared-web/components';
import { trackEvent } from '@ubeya/shared-web/analytics/amplitude';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useFormattingMap from '@ubeya/shared-web/hooks/useFormattingMap';
import useToaster from '@ubeya/shared/hooks/useToaster';
import { ReactComponent as ExcelIcon } from '@ubeya/shared-web/assets/file-excel.svg';
import exportLedgerToExcel from '../ledgerExport';
import LedgerTab from './LedgerTab';

const LeaveLedgerModal = ({
  employeeId,
  employeeName,
  history,
  management,
  onReverseAdjust,
  onLoadMore,
  hasMore,
  isLoadingMore,
  fetchFullLedger,
  onClose
}) => {
  const { t, currency } = useContext(ConfigContext);
  const formattingMap = useFormattingMap();
  const { addResponseError } = useToaster();

  const handleExport = useCallback(async () => {
    trackEvent('leave_ledger_export_clicked', {
      module: 'Employee Card',
      context: 'Leave Ledger History',
      employeeId
    });

    try {
      const ledger = await fetchFullLedger();
      await exportLedgerToExcel({ ledger, employeeName, t, formattingMap, currency });
    } catch (error) {
      addResponseError(error);
    }
  }, [employeeId, employeeName, fetchFullLedger, t, formattingMap, currency, addResponseError]);

  const hasLedgerEntries = (history?.ledgerTotal ?? 0) > 0;

  return (
    <Modal
      title={
        <FlexSpace>
          {t('employeeLeave_ledger_modalTitle')}

          {hasLedgerEntries && (
            <CircleIcon icon={ExcelIcon} tooltip={t('exportToExcel')} onClick={handleExport} isWaitingForResponse />
          )}
        </FlexSpace>
      }
      onClose={onClose}
      usePortal
      size="large"
      showConfirmButton={false}>
      <LedgerTab
        ledger={history?.ledger || []}
        ledgerTotal={history?.ledgerTotal}
        management={management}
        onReverseAdjust={onReverseAdjust}
        onLoadMore={onLoadMore}
        hasMore={hasMore}
        isLoadingMore={isLoadingMore}
      />
    </Modal>
  );
};

export default LeaveLedgerModal;
